// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Basic styling for printable documents - Inherited from PrintableQuote.css conceptually */
.printable-container {
  font-family: 'Arial', sans-serif;
  padding: 20px;
  max-width: 800px; /* Adjust as needed */
  margin: auto;
  background-color: #fff;
  color: #000;
}

.printable-header {
  text-align: center;
  margin-bottom: 30px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 15px;
}

.printable-header h1 {
  margin: 0 0 5px 0;
  font-size: 1.8em;
}

.printable-header p {
  margin: 0;
  font-size: 1em;
  color: #333;
}

section {
  margin-bottom: 25px;
}

section h2 {
  font-size: 1.3em;
  margin-bottom: 15px; /* Increased margin for section titles */
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
  color: #111;
}

.parties p,
.subject p,
.payment p,
.additional-terms p {
  margin: 8px 0; /* Increased paragraph margin */
  line-height: 1.5;
  font-size: 0.95em;
}

/* Table Styling (Similar to Quote) */
.specification table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 0.9em;
}

.specification th,
.specification td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  vertical-align: top;
}

.specification th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.specification td:first-child { /* № */
  text-align: center;
  width: 40px; /* Fixed width for number column */
}

.specification td:last-child { /* Сумма */
  text-align: right;
}

/* Signature Section */
.signatures {
  margin-top: 40px;
}

.signature-blocks {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee; /* Optional separator */
}

.signature-block {
  width: 45%; /* Adjust width as needed */
  font-size: 0.9em;
}

.signature-block p {
  margin-bottom: 5px;
}

.signature-block strong {
  font-weight: bold;
}

.printable-footer {
  margin-top: 40px;
  padding-top: 15px;
  border-top: 1px solid #ccc;
  text-align: center;
  font-size: 0.8em;
  color: #555;
}

/* Print-specific styles */
@media print {
  body {
    margin: 0;
    padding: 0;
    background-color: #fff;
  }
  .printable-container {
    max-width: 100%;
    box-shadow: none;
    margin: 0;
    padding: 10mm;
    border: none;
  }
  .no-print {
    /* display: none; */
  }
  .specification th,
  .specification td {
    border: 1px solid #aaa !important;
  }
  tr, section, .signature-block {
    page-break-inside: avoid;
  }
  h1, h2 {
    page-break-after: avoid;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/printable/PrintableContract.css"],"names":[],"mappings":"AAAA,2FAA2F;AAC3F;EACE,gCAAgC;EAChC,aAAa;EACb,gBAAgB,EAAE,qBAAqB;EACvC,YAAY;EACZ,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB,EAAE,wCAAwC;EAC7D,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;;EAIE,aAAa,EAAE,+BAA+B;EAC9C,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,gCAAgC,MAAM;EACpC,kBAAkB;EAClB,WAAW,EAAE,kCAAkC;AACjD;;AAEA,+BAA+B,UAAU;EACvC,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B,EAAE,uBAAuB;AACrD;;AAEA;EACE,UAAU,EAAE,2BAA2B;EACvC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE;IACE,SAAS;IACT,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,iCAAiC;EACnC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* Basic styling for printable documents - Inherited from PrintableQuote.css conceptually */\n.printable-container {\n  font-family: 'Arial', sans-serif;\n  padding: 20px;\n  max-width: 800px; /* Adjust as needed */\n  margin: auto;\n  background-color: #fff;\n  color: #000;\n}\n\n.printable-header {\n  text-align: center;\n  margin-bottom: 30px;\n  border-bottom: 1px solid #ccc;\n  padding-bottom: 15px;\n}\n\n.printable-header h1 {\n  margin: 0 0 5px 0;\n  font-size: 1.8em;\n}\n\n.printable-header p {\n  margin: 0;\n  font-size: 1em;\n  color: #333;\n}\n\nsection {\n  margin-bottom: 25px;\n}\n\nsection h2 {\n  font-size: 1.3em;\n  margin-bottom: 15px; /* Increased margin for section titles */\n  border-bottom: 1px solid #eee;\n  padding-bottom: 5px;\n  color: #111;\n}\n\n.parties p,\n.subject p,\n.payment p,\n.additional-terms p {\n  margin: 8px 0; /* Increased paragraph margin */\n  line-height: 1.5;\n  font-size: 0.95em;\n}\n\n/* Table Styling (Similar to Quote) */\n.specification table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n  font-size: 0.9em;\n}\n\n.specification th,\n.specification td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: left;\n  vertical-align: top;\n}\n\n.specification th {\n  background-color: #f2f2f2;\n  font-weight: bold;\n}\n\n.specification td:first-child { /* № */\n  text-align: center;\n  width: 40px; /* Fixed width for number column */\n}\n\n.specification td:last-child { /* Сумма */\n  text-align: right;\n}\n\n/* Signature Section */\n.signatures {\n  margin-top: 40px;\n}\n\n.signature-blocks {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid #eee; /* Optional separator */\n}\n\n.signature-block {\n  width: 45%; /* Adjust width as needed */\n  font-size: 0.9em;\n}\n\n.signature-block p {\n  margin-bottom: 5px;\n}\n\n.signature-block strong {\n  font-weight: bold;\n}\n\n.printable-footer {\n  margin-top: 40px;\n  padding-top: 15px;\n  border-top: 1px solid #ccc;\n  text-align: center;\n  font-size: 0.8em;\n  color: #555;\n}\n\n/* Print-specific styles */\n@media print {\n  body {\n    margin: 0;\n    padding: 0;\n    background-color: #fff;\n  }\n  .printable-container {\n    max-width: 100%;\n    box-shadow: none;\n    margin: 0;\n    padding: 10mm;\n    border: none;\n  }\n  .no-print {\n    /* display: none; */\n  }\n  .specification th,\n  .specification td {\n    border: 1px solid #aaa !important;\n  }\n  tr, section, .signature-block {\n    page-break-inside: avoid;\n  }\n  h1, h2 {\n    page-break-after: avoid;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
